// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/customers/services/customerGroupService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { GrupoCliente, CustomerGroupInsert, CustomerGroupUpdate } from '../types';

// A API Udisys ainda não tem endpoint dedicado de grupos de clientes,
// então usamos os dados que chegam junto com clientes ou uma rota futura.
// Por ora este service está preparado para quando o endpoint existir.
const BASE = '/api/grupos-clientes';

export const customerGroupService = {
  async getAll(): Promise<GrupoCliente[]> {
    const { data } = await apiClient.get<GrupoCliente[]>(BASE);
    return data;
  },

  async getActive(): Promise<GrupoCliente[]> {
    const { data } = await apiClient.get<GrupoCliente[]>(BASE, {
      params: { ativo: true },
    });
    return data;
  },

  async getById(id: string | number): Promise<GrupoCliente> {
    const { data } = await apiClient.get<GrupoCliente>(`${BASE}/${id}`);
    return data;
  },

  async create(grupo: CustomerGroupInsert): Promise<GrupoCliente> {
    const { data } = await apiClient.post<GrupoCliente>(BASE, grupo);
    return data;
  },

  async update(id: string | number, grupo: CustomerGroupUpdate): Promise<GrupoCliente> {
    const { data } = await apiClient.put<GrupoCliente>(`${BASE}/${id}`, grupo);
    return data;
  },

  async delete(id: string | number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },

  async search(query: string): Promise<GrupoCliente[]> {
    const { data } = await apiClient.get<GrupoCliente[]>(BASE, {
      params: { busca: query },
    });
    return data;
  },
};
